export default __webpack_public_path__ + "static/media/tinder.ce875a92.png";